import { NewModal } from 'lib/components';
import React from 'react';
import { Button } from 'react-covideo-common';
import { Flex } from '../styles/layout';

type Props = {
  title: string;
  content: React.ReactNode;
  secondaryButtonText: string;
  primaryButtonText: string;
  handleSubmit: (e?: React.MouseEvent) => void;
  handleModalClose: () => void;
  primaryButtonType?: 'destructive' | 'primary' | 'red';
  isPrimaryButtonDisabled?: boolean;
  handleSecondarySubmit?: (e?: React.MouseEvent) => void;
};

export const ModalPrompt = ({
  title,
  content,
  primaryButtonText,
  secondaryButtonText,
  handleModalClose,
  handleSubmit,
  handleSecondarySubmit,
  primaryButtonType = 'primary',
  isPrimaryButtonDisabled = false,
}: Props) => {
  return (
    <NewModal
      headerText={title}
      closeModal={handleModalClose}
      style={{
        content: { width: 592, maxWidth: 592 },
      }}
    >
      <Flex>
        {content}
        <Flex flexDirection='row' gap='8px' justifyContent='flex-end'>
          <Button
            text={primaryButtonText}
            disabled={isPrimaryButtonDisabled}
            variant={primaryButtonType}
            onClick={handleSubmit}
          />
          <Button
            text={secondaryButtonText}
            onClick={handleSecondarySubmit || handleModalClose}
            variant='secondary'
          />
        </Flex>
      </Flex>
    </NewModal>
  );
};
